import { render, staticRenderFns } from "./workflowDialog.vue?vue&type=template&id=3b6de9aa&"
import script from "./workflowDialog.vue?vue&type=script&lang=ts&"
export * from "./workflowDialog.vue?vue&type=script&lang=ts&"
import style0 from "./workflowDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports